import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import LearningPlatformLink from './WaffleItems/LearningPlatformLink';
import { handleEscKeyDown } from '../../../../../../Accessibility/KeyboardEvents';
import ClientPortalLink from './WaffleItems/ClientPortalLink';
import CoachingPortalLink from './WaffleItems/CoachingPortalLink';
import EnterprisePortalLink from './WaffleItems/EnterprisePortalLink';
import { T } from '../../../../../../Translations';

interface Props {
  ariaLabelledby?: string;
  close: () => void;
}

const ExpandedContent: React.FC<Props> = ({ ariaLabelledby, close }) => (
  <div
    className={clsx([
      'shadow-waffleShadow',
      'absolute border-slate-300 border-solid z-100 rounded-md',
      'bg-white list-none min-w-max',
      'left-[10px] lg:left-[-25px] top-10 py-2 px-1',
    ])}
    onKeyDown={handleEscKeyDown(close)}
    aria-labelledby={ariaLabelledby}
  >
    <div className={clsx(['text-slate-800 pl-6 pt-3 pb-3 text-sm'])}>
      <T kind="Switch to" />
    </div>
    <ul className={clsx(['p-0 m-0'])}>
      <EnterprisePortalLink />
      <LearningPlatformLink />
      <ClientPortalLink />
      <CoachingPortalLink />
    </ul>
  </div>
);

export default observer(ExpandedContent);
